<template lang='pug' functional>
  .loader(:class='props.size')
    .loader-spinner
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }
}
</script>

<style lang='scss' scoped>
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;

    &.small {
      min-height: 200px;
    }

    &.medium {
      min-height: 400px;
    }

    &.large {
      min-height: 600px;
    }
  }
</style>
